import React, { useEffect, useState, useContext, useMemo } from "react";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Typography,
  Stack,
  Box,
  Button,
  Grid,
  Avatar,
  IconButton,
} from "@mui/material";
import { useMutation, useQuery } from "@apollo/client";
//date picker
import moment from "moment";
//Icons
import { LuSave } from "react-icons/lu";
import { BiMinusCircle } from "react-icons/bi";
import { IoAddCircleOutline } from "react-icons/io5";
//Import from project
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import {
  GET_DISBURSEMENT_BY_ID,
  PAY_DISBURSEMENT,
} from "../../Schema/Disbursement";
import ListAccountType from "./ListAccountType";

export default function CreatePayDisbursement({
  open,
  handleClose,
  editData,
  setRefetch,
}) {
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [requireField, setRequireField] = useState(false);

  // const [date, setDate] = useState(new Date());
  const [tableData, setTableData] = useState([]);
  const [disbursementList, setDisbursementList] = useState([]);
  // console.log("disbursementList::", disbursementList);

  const { refetch } = useQuery(GET_DISBURSEMENT_BY_ID, {
    variables: {
      id: editData?._id,
    },
    onCompleted: ({ getDisbursementId }) => {
      // console.log("getDisbursementId:::", getDisbursementId);
      setTableData(getDisbursementId);
      setLoading(false);

      if (getDisbursementId?.disbursements?.length !== 0) {
        let itemFromBackend = [];
        getDisbursementId?.disbursements?.map((d, index) => {
          let itemExpenseFromBackend = [];
          d?.items?.map((e, itemIndex) => {
            // console.log("e==>", e);
            let itemPaymentsFromBackend = [];
            if (e?.payments !== null) {
              e?.payments?.map((i, paymentIndex) => {
                const allPayments = {
                  subKey: "item" + itemIndex + 1 + Date.now(),
                  paymentDate: i?.paymentDate,
                  paymentMethod: i?.paymentMethod,
                  pricePaidKHR: i?.pricePaidKHR,
                  pricePaidUSD: i?.pricePaidUSD,
                  key: "payments" + paymentIndex + 1 + Date.now(),
                };
                itemPaymentsFromBackend?.push(allPayments);
              });
            }

            const allExpenseFromBackend = {
              mainKey: index + Date.now(),
              invDate: e?.invDate,
              invNo: e?.invNo,
              description: e?.description,
              supplierId: e?.supplierId,
              supplierName: e?.supplierName,
              qty: e?.qty,
              exchangeRate: e?.exchangeRate,
              priceKHR: e?.priceKHR,
              priceUSD: e?.priceUSD,
              key: "item" + itemIndex + 1 + Date.now(),
              itemUniqueId: e?.itemUniqueId,
              payments: e?.payments === null ? [] : itemPaymentsFromBackend,
            };

            if (d?.uniqueId === e?.itemUniqueId) {
              itemExpenseFromBackend?.push(allExpenseFromBackend);
            }
          });
          // console.log("d::", d);

          const allItemFromBackend = {
            accountTypeId: d?.accountTypeId,
            accountTypeName: d?.code_account + " - " + d?.accountType,
            items: itemExpenseFromBackend,
            key: index + Date.now(),
            uniqueId: d?.uniqueId,
          };
          itemFromBackend?.push(allItemFromBackend);
        });
        setDisbursementList([...itemFromBackend]);
      }
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  // console.log("disbursementList::", disbursementList);

  useEffect(() => {
    refetch();
  }, [open, editData?._id]);

  const [payDisbursement] = useMutation(PAY_DISBURSEMENT, {
    onCompleted: ({ payDisbursement }) => {
      setSubmitLoading(false);
      // console.log("payDisbursement::", payDisbursement);
      if (payDisbursement?.status === true) {
        setAlert(true, "success", payDisbursement?.message);
        handleClose();
        refetch();
      } else {
        setAlert(true, "error", payDisbursement?.message);
      }
    },
    onError: (error) => {
      setSubmitLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  const handleSubmit = () => {
    let createStatus = false;
    const BreakException = {};
    try {
      if (disbursementList?.length !== 0) {
        disbursementList?.forEach(function (elem) {
          if (elem?.accountTypeId !== undefined && elem?.accountTypeId !== "") {
            createStatus = true;
          } else {
            setSubmitLoading(false);
            setRequireField(true);
            createStatus = false;
            throw BreakException;
          }
        });
      } else {
        setSubmitLoading(false);
        setRequireField(true);
      }
    } catch (e) {
      if (e !== BreakException) throw e;
    }

    // console.log("asdfasdf::", submitLoading)

    if (createStatus) {
      // console.log("first", disbursementList);
      let itemToSubmit = [];
      disbursementList?.map((d) => {
        let itemExpense = [];
        d?.items?.map((e) => {
          let itemPayments = [];
          e?.payments?.map((p) => {
            const allPayments = {
              paymentDate: moment(p?.paymentDate).format("YYYY-MM-DD"),
              paymentMethod: p?.paymentMethod,
              pricePaidKHR: p?.pricePaidKHR,
              pricePaidUSD: p?.pricePaidUSD,
            };
            if (e?.key === p?.subKey) {
              itemPayments?.push(allPayments);
            }
          });

          const allExpenseData = {
            invDate: moment(e?.invDate).format("YYYY-MM-DD"),
            invNo: e?.invNo,
            description: e?.description,
            supplierId: e?.supplierId,
            qty: e?.qty,
            exchangeRate: e?.exchangeRate,
            priceKHR: e?.priceKHR,
            priceUSD: e?.priceUSD,
            payments: itemPayments,
          };

          if (d?.key === e?.mainKey || d?.uniqueId === e?.itemUniqueId) {
            itemExpense?.push(allExpenseData);
          }
        });
        const allItemToSubmit = {
          accountType: d?.accountTypeId,
          items: itemExpense,
        };
        itemToSubmit?.push(allItemToSubmit);
      });

      // console.log("itemToSubmit::", itemToSubmit);
      setSubmitLoading(true);
      payDisbursement({
        variables: {
          id: editData?._id,
          input: itemToSubmit,
        },
      });
    }
  };

  return (
    <Dialog open={open} className="dialog-container" fullWidth fullScreen>
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              Create Pay Disbursement
            </Typography>
          </Stack>
          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <BiMinusCircle className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container rowSpacing={1} columnSpacing={3}>
          <Grid item xs={6} sm={6} md={3} lg={3} xl={2.4}>
            <Stack
              direction="column"
              justifyContent="center"
              sx={{ height: "100%" }}
            >
              <Stack direction="row" spacing={1}>
                <Typography className="select-title">Date :</Typography>
                <Typography className="select-title">
                  {moment(tableData?.date).format("DD-MM-YYYY")}
                </Typography>
              </Stack>
            </Stack>
          </Grid>

          <Grid item xs={6} sm={6} md={3} lg={3} xl={2.4}>
            <Stack
              direction="column"
              justifyContent="center"
              sx={{ height: "100%" }}
            >
              <Stack direction="row" spacing={1}>
                <Typography className="select-title">Last save at :</Typography>
                <Typography className="select-title">
                  {moment(tableData?.lastSave).format("DD-MM-YYYY hh:mm a")}
                </Typography>
              </Stack>
            </Stack>
          </Grid>

          {tableData?.updatedBy ? (
            <Grid item xs={6} sm={6} md={3} lg={3} xl={2.4}>
              <Stack direction="row" spacing={1} sx={{ height: "100%" }}>
                <Stack direction="column" justifyContent="center">
                  <Typography className="select-title">
                    Last update by :
                  </Typography>
                </Stack>
                <Stack className="update-by" direction="row" spacing={1}>
                  <Avatar
                    src={tableData?.updatedBysrc}
                    alt={tableData?.updatedBy}
                    sx={{ width: "38px", height: "38px", marginTop: "2px" }}
                  />
                  <Stack direction="column" justifyContent="center">
                    <Typography className="name">
                      {tableData?.updatedBy}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Grid>
          ) : null}

          <Box flexGrow={1} />

          <Grid item xs={6} sm={6} md={3} lg={3} xl={4.8}>
            <Stack direction="row" justifyContent="right">
              {submitLoading ? (
                <Button
                  className="btn-save"
                  startIcon={<LuSave alt="CreateIcon" className="icon-add" />}
                >
                  Loading...
                </Button>
              ) : (
                <Button
                  onClick={handleSubmit}
                  className="btn-save"
                  startIcon={<LuSave alt="CreateIcon" className="icon-add" />}
                >
                  Save
                </Button>
              )}
            </Stack>
          </Grid>
        </Grid>

        <Box sx={{ marginTop: "10px" }}>
          <Grid container rowSpacing={2}>
            <Grid item xs={12}>
              <Stack
                sx={{
                  borderBottom: "1px solid #0f81c2",
                  width: "100%",
                }}
                direction="row"
                justifyContent="space-between"
              >
                <Stack direction="column" justifyContent="center">
                  <Typography className="field-title-kh">
                    ប្រភេទចំណាយ
                  </Typography>
                </Stack>
              </Stack>
            </Grid>

            <Grid item xs={12}>
              <ListAccountType
                disbursementList={disbursementList}
                setDisbursementList={setDisbursementList}
                requireField={requireField}
                setRequireField={setRequireField}
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
